<app-loading *ngIf="contentReady"></app-loading>
<nav class="mobile-topbar noPrint">
  <div class="mobile-topbar-language">
    <button
      type="button"
      class="mobile-icon-btn language-toggle-btn"
      [class.open]="languageDropdownOpen"
      (click)="toggleLanguageDropdown($event)"
    >
      <img
        *ngIf="currentLanguage === 'ar'"
        class="language-flag current-language-flag"
        src="/assets/ar.png"
        [alt]="'Arabic' | transloco"
      />
      <img
        *ngIf="currentLanguage === 'en'"
        class="language-flag current-language-flag"
        src="/assets/en.png"
        [alt]="'English' | transloco"
      />
      <img
        *ngIf="currentLanguage === 'fr'"
        class="language-flag current-language-flag"
        src="/assets/fr.png"
        [alt]="'French' | transloco"
      />
      <i class="fa-solid fa-chevron-down header-icon language-toggle-arrow" aria-hidden="true"></i>
    </button>

    <div *ngIf="languageDropdownOpen" class="topbar-language-options">
      <button
        type="button"
        class="language-option"
        [class.selected]="currentLanguage === 'ar'"
        (click)="setLanguage('ar', $event)"
      >
        <img class="language-flag" src="/assets/ar.png" [alt]="'Arabic' | transloco" />
        <span>{{ "Arabic" | transloco }}</span>
      </button>
      <button
        type="button"
        class="language-option"
        [class.selected]="currentLanguage === 'en'"
        (click)="setLanguage('en', $event)"
      >
        <img class="language-flag" src="/assets/en.png" [alt]="'English' | transloco" />
        <span>{{ "English" | transloco }}</span>
      </button>
      <button
        type="button"
        class="language-option"
        [class.selected]="currentLanguage === 'fr'"
        (click)="setLanguage('fr', $event)"
      >
        <img class="language-flag" src="/assets/fr.png" [alt]="'French' | transloco" />
        <span>{{ "French" | transloco }}</span>
      </button>
    </div>
  </div>

  <a class="mobile-logo" routerLink="/Home.mobile" (click)="close()">
    <img src="/assets/logo-mobile.png" [alt]="'Logo' | transloco" />
  </a>

  <button
    *ngIf="tokenExists"
    type="button"
    class="mobile-menu-btn"
    (click)="openMenuToggle()"
    [attr.aria-label]="'Toggle navigation' | transloco"
  >
    <span class="logo-color-burger" aria-hidden="true">
      <span></span>
      <span></span>
      <span></span>
    </span>

    <small *ngIf="cartItems.length > 0 && showCart" class="top-cart-badge">
      {{ cartItemCount }}
    </small>
  </button>
</nav>

<div *ngIf="openMenu" class="mobile-overlay noPrint" (click)="close()">
  <div class="mobile-drawer" (click)="$event.stopPropagation()">

    <div class="drawer-head">
      <div>
        <strong>{{ "Menu" | transloco }}</strong>
        <span>{{ "Control Panel" | transloco }}</span>
      </div>

      <button type="button" class="drawer-close" (click)="close()">
        <i class="fa-solid fa-xmark header-icon" aria-hidden="true"></i>
      </button>
    </div>

    <ul class="sidebar-menu mobile-sidebar-menu">

      <ng-container *ngIf="tokenExists && menuReady">

        <li
          *ngFor="let item of menuItems"
          routerLinkActive="active"
          [routerLink]="item.route"
          (click)="close()"
          [attr.title]="item.label | transloco"
        >
          <i class="menu-fa-icon" [ngClass]="item.icon" aria-hidden="true"></i>

          <span>
            {{ item.label | transloco }}

            <small
              *ngIf="item.showUpcomingBadge && upcoming > 0"
              class="badge"
            >
              {{ upcoming }}
            </small>
          </span>
        </li>

      </ng-container>

      <!-- Cart -->
      <li
        *ngIf="cartItems.length > 0 && showCart"
        class="cart-menu-item"
        (click)="cartPopUpOpen()"
        [attr.title]="'Cart' | transloco"
      >
        <i class="fa-solid fa-cart-shopping menu-fa-icon" aria-hidden="true"></i>
        <span>{{ "Cart" | transloco }}</span>
        <small class="badge">{{ cartItemCount }}</small>
      </li>

      <!-- Language -->
      <li
        class="language-menu-item"
        [class.open]="languageDropdownOpen"
        (click)="toggleLanguageDropdown($event)"
        [attr.title]="'Language' | transloco"
      >
        <i class="fa-solid fa-globe menu-fa-icon" aria-hidden="true"></i>
        <span>{{ "Language" | transloco }}</span>
        <i class="fa-solid fa-chevron-down header-icon language-arrow" aria-hidden="true"></i>
      </li>

      <li *ngIf="languageDropdownOpen" class="language-options-wrap">
        <button
        type="button"
        class="language-option"
        [class.selected]="currentLanguage === 'ar'"
        (click)="setLanguage('ar', $event)"
        [attr.title]="'Arabic' | transloco"
      >
          <img class="language-flag" src="/assets/ar.png" [alt]="'Arabic' | transloco" />
          <span>{{ "Arabic" | transloco }}</span>
        </button>
        <button
        type="button"
        class="language-option"
        [class.selected]="currentLanguage === 'en'"
        (click)="setLanguage('en', $event)"
        [attr.title]="'English' | transloco"
      >
          <img class="language-flag" src="/assets/en.png" [alt]="'English' | transloco" />
          <span>{{ "English" | transloco }}</span>
        </button>
        <button
        type="button"
        class="language-option"
        [class.selected]="currentLanguage === 'fr'"
        (click)="setLanguage('fr', $event)"
        [attr.title]="'French' | transloco"
      >
          <img class="language-flag" src="/assets/fr.png" [alt]="'French' | transloco" />
          <span>{{ "French" | transloco }}</span>
        </button>
      </li>

      <!-- Logout -->
      <li *ngIf="tokenExists" (click)="logout()" [attr.title]="'Log out' | transloco">
        <i class="fa-solid fa-right-from-bracket menu-fa-icon" aria-hidden="true"></i>
        <span>{{ "Log out" | transloco }}</span>
      </li>

    </ul>
  </div>
</div>

<div *ngIf="cartPopUp" class="mobile-cart-popup noPrint" (click)="closeCart()">
  <div class="cart-modal" (click)="$event.stopPropagation()">

    <button type="button" class="close-btn" (click)="closeCart()">
      <i class="fa-solid fa-xmark header-icon" aria-hidden="true"></i>
    </button>

    <div class="cart-title">
      <i class="fa-solid fa-cart-shopping cart-title-icon" aria-hidden="true"></i>
      <h4>{{ "Cart" | transloco }}</h4>
      <span>{{ cartItemCount }} {{ "Items" | transloco }}</span>
    </div>

    <div class="cart-cont" *ngIf="cartItems.length > 0; else emptyCart">
      <div *ngFor="let item of cartItems" class="cart-item">
        <span>{{ item.name_ar || item.name_en || item.name }} ({{ item.cartItemType === 'service' || (!item.cartItemType && item.quantity === undefined) ? 'خدمة' : 'منتج' }})</span>

        <button
          type="button"
          class="clear-btn-cart"
          (click)="removeFromCart(item)"
        >
          <i class="fa-solid fa-trash header-icon" aria-hidden="true"></i>
        </button>
      </div>
    </div>

    <ng-template #emptyCart>
      <p class="empty-cart">{{ "Cart is empty" | transloco }}</p>
    </ng-template>

    <button
      *ngIf="cartItems.length > 0"
      (click)="quickOrder()"
      type="button"
      class="primary-btn"
    >
      {{ "proceed to add order" | transloco }}
    </button>

    <button (click)="closeCart()" type="button" class="secondary-btn">
      {{ "close" | transloco }}
    </button>

  </div>
</div>
